/* eslint-disable no-unused-vars */
import React from 'react'
import {Combobox, Box, Text, VisuallyHidden, SSRProvider} from '@fuegokit/react'
import {AkChevronDownIcon} from '@fuegokit/fuegoicons-react'
import {useIsSSR} from 'react-aria'

import {
  StyledCombobox,
  StyledComboboxButton,
  StyledComboboxInput,
  StyledComboboxItem,
  StyledComboboxListbox,
  StyledComboboxPopover,
  StyledComboboxHeader,
  StyledComboboxSection,
  StyledComboboxText,
  StyledComboboxLabel,
  CustomItem,
  StyledComplexComboboxItem
} from '../../../src/components/Combobox/Styled'

const StyledComboboxExample = () => {
  return (
    <StyledCombobox>
      <Combobox.Label>Favorite ice cream</Combobox.Label>
      <Box
        className="my-combobox-container"
        sx={{
          display: 'flex'
        }}
      >
        <StyledComboboxInput />
        <StyledComboboxButton>
          <VisuallyHidden>Menu</VisuallyHidden>
          <AkChevronDownIcon />
        </StyledComboboxButton>
      </Box>
      {/* {args.description && <Text slot="description">{args.description}</Text>}
        {args.errorMessage && <Text slot="errorMessage">{args.errorMessage}</Text>} */}
      <StyledComboboxPopover>
        <StyledComboboxListbox>
          <StyledComboboxItem>Chocolate</StyledComboboxItem>
          <StyledComboboxItem>Mint</StyledComboboxItem>
          <StyledComboboxItem>Strawberry</StyledComboboxItem>
          <StyledComboboxItem>Vanilla</StyledComboboxItem>
        </StyledComboboxListbox>
      </StyledComboboxPopover>
    </StyledCombobox>
  )
}
export default StyledComboboxExample
